// import http from '@/base/public'
// import sysConfig from "@/config/sysConfig";

import store from '@/store'
import wgJson from  '../datajson/wgjson.json'
import sqJson from  '../datajson/sqjson.json'
import aqpqJson from  '../datajson/aqpq.json'
import cgpqJson from  '../datajson/cgpq.json'
import jtpqJson from  '../datajson/jtpq.json'
import zybjJson from  '../datajson/zybj.json'
import * as mapFunction from "./runMap";

let map;
let proxy;

let MapParam = {
    defaultCenter : [116.43529,39.793389],
    defaulZoom: 13,
    bjdzb : {},
    prevZoom : null
}

let MapObj = {
    curMarker:null
}

let OverlayGroupsMod = {
    wgPolygonGroup : null,
    wgTextGroup : null,
    sqPolygonGroup : null,
    sqTextGroup : null,
}

let OverlayGroups = {};



let Overlays = {
    wgPolygon:function (data){
        let cen = MapUtil.getCenterPoint(data.geometry.coordinates);
        let bjdata= MapParam.bjdzb[data.properties.name];
        // 创建多边形实例
        let polygon = new AMap.Polygon({
            path: data.geometry.coordinates,
            strokeWeight: 1.5, // 线条宽度，默认为 1
            strokeColor: '#457cfe', // 线条颜色
            fillColor: '#457cfe', // 填充颜色
            fillOpacity: 0, // 填充透明度
            zIndex:10,
            extData:{code:bjdata.bjcode}
        }).on("click",function (e){
            MapFun.loadCurMarker({lnglat:e.lnglat});
            MapFun.wgPolygonClick(this,e.lnglat);
        });
        OverlayGroups.wgPolygonGroup.addOverlay(polygon);

        //创建文字
        let text = new AMap.Text({
            text: "<div>"+bjdata.bjname+"</div>",
            position: cen,
            extData:{code:bjdata.bjcode},
            zIndex:11,
            style:{
                'color':'#457cfe',
                'border': '0px solid #ccc',
                'background': 'none',
                'text-align': 'center',
                'font-size': '12px',
            }
        }).on("click",function (e){
            MapFun.loadCurMarker({lnglat:e.lnglat});
            MapFun.wgPolygonClick(this,e.lnglat);
        });
        OverlayGroups.wgTextGroup.addOverlay(text);

    },
    sqPolygon:function (data){
        let cen = MapUtil.getCenterPoint(data.geometry.coordinates);
        let bjdata= MapParam.bjdzb[data.properties.name]||{};
        // 创建多边形实例
        let polygon = new AMap.Polygon({
            path: data.geometry.coordinates,
            strokeWeight: 1.5, // 线条宽度，默认为 1
            strokeColor: '#457cfe', // 线条颜色
            fillColor: '#457cfe', // 填充颜色
            fillOpacity: 0.4, // 填充透明度
            zIndex:20,
            extData:{code:bjdata.bjcode}
        }).on("click",function (e){
            MapFun.loadCurMarker({lnglat:e.lnglat});
            MapFun.wgPolygonClick(this,e.lnglat);
        });
        OverlayGroups.sqPolygonGroup.addOverlay(polygon);

        //创建文字
        let text = new AMap.Text({
            text: "<div>"+bjdata.bjname+"</div>",
            position: cen,
            extData:{code:bjdata.bjcode},
            zIndex:21,
            style:{
                'color':'#457cfe',
                'border': '0px solid #ccc',
                'background': 'none',
                'text-align': 'center',
                'font-size': '12px',
            }
        }).on("click",function (e){
            MapFun.loadCurMarker({lnglat:e.lnglat});
            MapFun.wgPolygonClick(this,e.lnglat);
        });
        OverlayGroups.sqTextGroup.addOverlay(text);
    }
}


let MapFun = {
    mapInit(param){
        this.mapDestroy();

        proxy = param.proxy;
        map = new AMap.Map('map', {
            resizeEnable: true,
            center:MapParam.defaultCenter,
            zoom: MapParam.defaulZoom,
        });

        map.on("click", function (e) {
            console.log(map.getCenter())
            console.log(map.getZoom())
            MapFun.loadCurMarker({lnglat:e.lnglat});
        });
        map.on("complete", function () {
            MapFun.layerInit();
            MapFun.pluginInit();
            MapFun.geoFunInit()
        });

        map.on('zoomstart', () => {
            MapParam.prevZoom = map.getZoom();
        });

        map.on('zoomend', () => {
            MapFun.zoomChange()
        });

    },
    mapDestroy(){
        if(map){
            map.destroy();
            map = null;
        }
    },
    zoomChange(){
        let nowZoom = map.getZoom();
        if(MapParam.prevZoom<15&&nowZoom>=15){
            OverlayGroups.sqTextGroup.show();
        }else if(MapParam.prevZoom>=15&&nowZoom<15){
            OverlayGroups.sqTextGroup.hide();
        }
    },
    autoSearch(autoOptions){
        let auto = new AMap.Autocomplete(autoOptions);
        AMap.event.addListener(auto, "select", select);//注册监听，当选中某条记录时会触发
        function select(e) {
            MapFun.loadCurMarker({lnglat:e.poi.location,addressName:e.poi.name})
        }
    },
    pluginInit(){
        AMap.plugin([
            'AMap.ToolBar',
        ], function(){
            // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
            map.addControl(new AMap.ToolBar({
                // 简易缩放模式，默认为 false
                liteStyle: true
            }));
        });
    },
    geoFunInit(){
        AMap.plugin('AMap.Geolocation', function () {
            let geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                // timeout: 10000,
                // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20),
                //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                zoomToAccuracy: true,
                //  定位按钮的排放位置,  RB表示右下
                buttonPosition: 'RB'
            })
            // map.addControl(geolocation);
            // geolocation.getCurrentPosition()
            // new AMap.event.addListener(geolocation, 'complete', onComplete)
            // new AMap.event.addListener(geolocation, 'error', onError)
            geolocation.getCurrentPosition(function (status, result) {
                if (status == 'complete') {
                    console.log("定位成功");
                    onComplete(result)
                } else {
                    console.log("定位失败");
                    onError(result)
                }
            });

            function onComplete(data) {
                // data是具体的定位信息
                map.setCenter([data.position.lng,data.position.lat])
                MapFun.loadCurMarker({lnglat:data.position},function () {
                    MapFun.getCurPolygonCode();
                })
            }

            function onError(data) {
                // 定位出错
            }
        })
    },
    layerInit(){
        OverlayGroups = JSON.parse(JSON.stringify(OverlayGroupsMod));
        for(let key in OverlayGroups){
            OverlayGroups[key] = new AMap.OverlayGroup();
            map.add(OverlayGroups[key])
        }

        // MapFun.wgPolygonInit();
    },
    selDzbDtbj(fun){
        proxy.$axios.get("/jgfast/wgsj/selDzbDtbj").then((res) => {
            if(res.code=="00000"){
                MapParam.bjdzb = res.data;
                fun();
            }
        });
    },
    wgPolygonInit(){
        MapFun.selDzbDtbj(function () {
            let wglist = wgJson.features;
            for(let i in wglist){
                Overlays.wgPolygon(wglist[i]);
            }

            let sqlist = sqJson.features;
            for(let i in sqlist){
                Overlays.sqPolygon(sqlist[i]);
            }

            OverlayGroups.sqTextGroup.hide();
        });
    },
    loadCurMarker({lnglat,addressName},fun){
        if(MapObj.curMarker){
            map.remove(MapObj.curMarker);
            MapObj.curMarker = null;
        }

        map.setCenter([lnglat.lng,lnglat.lat])

        let marker = new AMap.Marker({
            // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
            position: [lnglat.lng, lnglat.lat],
            offset: new AMap.Pixel(-13, -30),
            icon: new AMap.Icon({
                image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
                size: new AMap.Size(30, 40),  //图标所处区域大小
                imageSize: new AMap.Size(30, 40) //图标大小
            })
        });
        marker.setMap(map);
        MapObj.curMarker = marker;

        store.state.lnglat = [lnglat.lng, lnglat.lat];
        if(addressName){
            store.state.addressName = addressName;
        }else {
            AMap.plugin('AMap.Geocoder', function () {
                let geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                });
                geocoder.getAddress([lnglat.lng, lnglat.lat], function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        store.state.addressName = result.regeocode.formattedAddress;
                    }
                });
            })
        }

        if(fun){
            fun()
        }
    },
    wgPolygonClick(e,point){
        if(true){
            return
        }

        let data = e.getExtData()
        store.state.afcsMapVal = data.code;
        this.getAfpq(point);
        this.getIsZybjIn(point);
    },
    getAfpq(point){
        let pq = [];
        let cgpqList = cgpqJson.features;
        for(let i in cgpqList){
            let isPointInRing = AMap.GeometryUtil.isPointInRing(point,cgpqList[i].geometry.coordinates);
            if(isPointInRing){
                let bjdata= MapParam.bjdzb[cgpqList[i].properties.name];
                if(bjdata){
                    pq.push(bjdata.bjcode);
                    break;
                }
            }
        }
        let jtpqList = jtpqJson.features;
        for(let i in jtpqList){
            let isPointInRing = AMap.GeometryUtil.isPointInRing(point,jtpqList[i].geometry.coordinates);
            if(isPointInRing){
                let bjdata= MapParam.bjdzb[jtpqList[i].properties.name];
                if(bjdata){
                    pq.push(bjdata.bjcode);
                    break;
                }
            }
        }
        let aqpqList = aqpqJson.features;
        for(let i in aqpqList){
            let isPointInRing = AMap.GeometryUtil.isPointInRing(point,aqpqList[i].geometry.coordinates);
            if(isPointInRing){
                let bjdata= MapParam.bjdzb[aqpqList[i].properties.name];
                if(bjdata){
                    pq.push(bjdata.bjcode);
                    break;
                }
            }
        }
        store.state.afpqMapVal = pq.join(",");
    },
    getIsZybjIn(point){
        store.state.isZybjIn= false;
        let zybjList = zybjJson.features;
        for(let i in zybjList){
            let isPointInRing = AMap.GeometryUtil.isPointInRing(point,zybjList[i].geometry.coordinates);
            if(isPointInRing){
                store.state.isZybjIn= true;
                break;
            }
        }
    },
    getCurPolygonCode(){
        let point = MapObj.curMarker.getPosition();
        let list = OverlayGroups.wgPolygonGroup.getOverlays()
        for(let i in list){
            let path = list[i].getPath();
            let isPointInRing = AMap.GeometryUtil.isPointInRing(point,path);
            if(isPointInRing){
                store.state.afcsMapVal =  [i].getExtData().code;
                break;
            }
        }
        this.getAfpq(point);
        this.getIsZybjIn(point);
    }
}

let MapUtil = {
    getCenterPoint:function (points){
        let point_num = points.length; //坐标点个数
        let X = 0, Y = 0, Z = 0;
        for(let i = 0; i< points.length; i++) {
            let point = points[i];
            let lat, lng, x, y, z;
            if(point['lat']){
                lat = parseFloat(point['lat']) * Math.PI / 180;
                lng = parseFloat(point['lng']) * Math.PI / 180;
            }else{
                lat = parseFloat(point[1]) * Math.PI / 180;
                lng = parseFloat(point[0]) * Math.PI / 180;
            }

            x = Math.cos(lat) * Math.cos(lng);
            y = Math.cos(lat) * Math.sin(lng);
            z = Math.sin(lat);
            X += x;
            Y += y;
            Z += z;
        }
        X = X / point_num;
        Y = Y / point_num;
        Z = Z / point_num;

        let tmp_lng = Math.atan2(Y, X);
        let tmp_lat = Math.atan2(Z, Math.sqrt(X * X + Y * Y));
        return [ tmp_lng * 180 / Math.PI,tmp_lat * 180 / Math.PI];
    }
};

export default MapFun;


